// based on rc-tree 1.14.9
'use strict';

module.exports = require('./src/');


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/vc-tree/index.js
// module id = 175
// module chunks = 0